import React, { useState, useEffect, useRef } from "react";
import ApiService from "./../../services/ApiService";
import { toast } from "react-toastify";
import { useNavigate,useLocation } from "react-router-dom";
import i18n from 'i18next';

const VerifyLogin = () => {
  const routeLocation = useLocation();
  const props = routeLocation.state;
  const [timer, setTimer] = useState(60);
  const [values, setValues] = useState(["", "", "", ""]); // Array for OTP input
  const [disableVerify, setDisableVerify] = useState(false);
  const inputRefs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);
  const timerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 0) {
          clearInterval(timerRef.current);
          setDisableVerify(true); // Disable verify button when timer runs out
        }
        return prevTimer > 0 ? prevTimer - 1 : 0;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 1) {
      setValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = value;
        return newValues;
      });
      if (value.length === 1 && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].current.focus();
      }
    } else if (value.length === 0) {
      setValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = "";
        return newValues;
      });
    }
  };

  // Handle key down events for backspace functionality
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      e.preventDefault();
      
      setValues((prevValues) => {
        const newValues = [...prevValues];
        
        // If current input has value, clear it
        if (newValues[index] !== "") {
          newValues[index] = "";
        } else if (index > 0) {
          // If current input is empty, move to previous input and clear it
          newValues[index - 1] = "";
          inputRefs.current[index - 1].current.focus();
        }
        
        return newValues;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    var otpValue = Object.values(values).join("");
    await ApiService.verifyOTP({ otp: otpValue, user: props?.id }).then(
      (response) => {
        if (response.status === 200) {
          const language = response.data.selected_language;
          i18n.changeLanguage(language);
          localStorage.setItem("token", response.data.accessToken);
          sessionStorage.setItem("userEPK", response.data.userEPK);
          sessionStorage.setItem("userRole", response.data.role);
          response?.data?.role === 1
            ? navigate("/parent/dashboard")
            : response?.data?.role === 2
            ? navigate("/physician/dashboard")
            : navigate("/");
          localStorage.setItem("role", response.data.role);
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleResendCode = async () => {
    await ApiService.resendOTP({ user: props?.id, username: props?.username }).then(
      (response) => {
        if (response.status === 200) {
			setValues(["", "", "", ""]);
			clearInterval(timerRef.current);
			setTimer(60); // Reset the timer
          setDisableVerify(false); // Enable the verify button
          timerRef.current = setInterval(() => {
            setTimer((prevTimer) => {
              if (prevTimer === 0) {
                clearInterval(timerRef.current);
                setDisableVerify(true); // Disable verify button when timer runs out
              }
              return prevTimer > 0 ? prevTimer - 1 : 0;
            });
          }, 1000);
          toast.success("OTP Resend successfully");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <main className="login-sec">
      <div className="container">
        <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="d-flex justify-content-center pb-5">
                  <a
                    href="index.html"
                    className="login-logo d-flex align-items-center"
                  >
                    <img src="/assets/img/nurture-logo.svg" alt="Nurture" />
                  </a>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-10">
                <div className="wrap d-md-flex">
                  <img
                    src="/assets/img/physician-login-img.jpg"
                    alt="Login-Image"
                  />
                  <div id="loginForm">
                    <h5>Enter your verification code</h5>
                    <p>Timer: {timer}</p> {/* Display timer */}
                    <form onSubmit={handleSubmit}>
                      <div className="form-group mb-4 d-lg-flex align-items-center">
                        {values.map((value, index) => (
                          <input
                            key={index}
                            type="text"
                            className="form-control mx-2 p-2 text-center"
                            value={value}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={inputRefs.current[index]}
                          />
                        ))}
                      </div>
                      <div className="mb-5">
                        <button
                          type="submit"
                          disabled={disableVerify}
                          className="btn btn-tmBlue w-100"
                        >
                          Verify Code
                        </button>
                      </div>
                    </form>
					{disableVerify &&
                    <div className="footer-text">
                      <p>
                        Don’t get a code?{" "}
                        <a
                          onClick={handleResendCode}						  
                          className="ml-1"
                          style={{ cursor: "pointer" }}
                        >
                          Resend Code
                        </a>
                      </p>
                    </div>
					}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default VerifyLogin;
